/// <reference path='../../interfaces/interfaces.d.ts' />

import IScope = angular.IScope;
import {IStateService} from 'angular-ui-router';

'use strict';

class EditModalEventController {
    public static $inject = [
        '$scope',
        '$state',
        '$uibModalInstance',
        '$uibModal',
        'User',
        'Calendar',
        'Orgs',
        'event',
        'toaster',
        'bsLoadingOverlayService'
    ];

    public occurrences;
    public datePickerConfig;
    public selectedEvent;
    public repeatCases = ['None', 'daily', 'weekly', 'monthly', 'yearly'];
    public eventTypes;
    public eventTypeIcons;
    public hasPermission;
    public isRepeatEvent = false;

    constructor(private $scope: IScope,
                private $state: IStateService,
                private $uibModalInstance: any,
                private $uibModal: any,
                private User: IUserService,
                private Calendar: any,
                private Org: IOrgsService,
                private event: any,
                private toaster: toaster.IToasterService,
                private bsLoadingOverlayService: IBsLoadingService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        // this.repeatCases = Calendar.getRepeatCases();
        
        this.hasPermission = User.hasPermission;
        this.eventTypes = Calendar.getEventTypes();
        this.selectedEvent = angular.copy(event);
        if(this.selectedEvent.rule){
            this.selectedEvent.rule =
                (this.selectedEvent.rule.split(' ').length > 1)
                    ? this.selectedEvent.rule.split(' ')[1]
                    : this.selectedEvent.rule;
        }

        if (this.selectedEvent.created_on && moment(this.selectedEvent.created_on).diff(this.selectedEvent.start) !== 0) {
            this.selectedEvent.start = moment(this.selectedEvent.created_on);
            this.selectedEvent.end.day(moment(this.selectedEvent.created_on).day());
            this.isRepeatEvent = true;
        }

        if (this.selectedEvent.end_recurring_period !== null) {
            this.selectedEvent.ends = 'on';
            this.selectedEvent.end_recurring_period = moment(this.selectedEvent.end_recurring_period).toDate();
            this.checkoccurrences();
        } else {
            this.selectedEvent.ends = 'never';
            this.selectedEvent.end_recurring_period = undefined;
        }

        this.selectedEvent['id'] = event.event_id || event.id;

        Calendar.makeTitle(this.selectedEvent);
        this.checkAllDayOption();

        $scope.$watch('event.selectedEvent.all_day', (newVal: boolean) => {
            if (newVal) {
                this.selectedEvent.start.hour(0).minute(0);
                this.selectedEvent.end.hour(23).minute(59);
            }
        });

        this.eventTypes = Calendar.getEventTypes();
        this.eventTypeIcons = Calendar.getEventTypeIcons();

        this.datePickerConfig = {
            formatDay: 'd',
            formatDayTitle: 'MMM yyyy',
            showWeeks: false,
            minDate: this.selectedEvent.start
        };
    }

    public editEvent = (event: ng.IFormController) => {
        event.$submitted = true;
        if (event.$valid) {
            if (this.selectedEvent.start.valueOf() > this.selectedEvent.end.valueOf()) {
                this.toaster.pop('warning', 'Validation Failed', 'Start date must be earlier than end date!');
            } else {
                let promise: any;
                if (this.selectedEvent.rule === 'none') {
                    this.selectedEvent.rule = undefined;
                }
                this.selectedEvent.end_recurring_period = (this.selectedEvent.ends !== 'never') ? this.selectedEvent.end_recurring_period : undefined;
                if (this.selectedEvent.ends === 'on') {
                    this.selectedEvent.end_recurring_period.setMinutes(this.selectedEvent.start.toDate().getMinutes());
                }
                if (this.selectedEvent.calendar_type === 'holidays') {
                    promise = this.Calendar.updateHoliday(this.selectedEvent);
                } else {
                    promise = this.Calendar.updateEvent(this.selectedEvent);
                }
                promise.then(() => {
                        this.$uibModalInstance.close(this.selectedEvent);
                        this.toaster.pop('success', 'Event Updated!');
                        this.$scope.$emit('$EL', 'calendar.save_event');
                    }, (response: Restangular.IResponse) => {
                        if (response.status === 400) {
                            this.toaster.pop('error', 'Validation Failed', response.data);
                        } else {
                            this.toaster.pop('error', 'Server error', 'Please try again later');
                        }
                    }
                );
            }
        } else {
            this.toaster.pop('error', 'Error saving event', 'Required fields are not filled correctly!');
        }
    }

    public changeAllDay = () => {
        if (this.selectedEvent.allDay) {
            this.selectedEvent.start.hour(0).minute(0);
            this.selectedEvent.end.hour(23).minute(59);
        } else {
            this.selectedEvent.start.hour(0).minute(0);
            this.selectedEvent.end.hour(23).minute(45);
        }
    }

    public fullEventEditor = () => {
        this.$uibModalInstance.close();

        switch (this.$state.$current['self']['name']) {
            case 'root.calendar': {
                this.$state.go('root.calendar.edit', { calendar_type: this.event.calendar_type, event_id: this.event.event_id });
                break;
            }                     
            case 'root.employees.details.calendar': {
                this.$state.go('root.employees.details.calendar.edit', { calendar_type: this.event.calendar_type, event_id: this.event.event_id });
                break;
            }            
            default: {
                this.$state.go('root');
            }
        }
    }

    public removeEvent = () => {
        let promise: any;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = 'Delete event';
                $scope.modalDetail = 'This event will be deleted.  Are you sure?';
                $scope.confirmButton = 'Delete event';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],
            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });
        
        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                if (this.selectedEvent.calendar_type === 'holidays'){
                    promise = this.Calendar.removeHoliday(this.selectedEvent.id);
                }else {
                    promise = this.Calendar.removeEvent(this.selectedEvent.id);
                }

                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                
                promise.finally(() => {
                    this.toaster.pop('success', 'Event Deleted!');
                    this.$scope.$emit('$EL', 'calendar.delete_event');

                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});

                    this.$uibModalInstance.close(this.selectedEvent);
                })

            } else {
                if (result.status === 403) {
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    this.toaster.pop('error', 'Permission Denied', "You don't have permission to delete this event.");
                } else if (result.status === 400) {
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    this.toaster.pop('warning', 'Validation Failed', result.data);
                }
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });

    }

    public setEventType(event: any): void {
        this.selectedEvent.event_type = event;
    }

    public checkAllDayOption(): void {
        if (this.selectedEvent.end !== null) {
            if (this.selectedEvent.end.diff(this.selectedEvent.start) >= 86340000) {
                this.selectedEvent.allDay = true;
            } else {
                this.selectedEvent.allDay = false;
            }
        }
    }

    public occurrencesChange(): void {
        if (this.occurrences > 0) {
            this.occurrences = parseInt(this.occurrences, 10);
            let dateDifferance: number = this.occurrences - 1;
            let newDate: any = this.selectedEvent.start.toDate();

            switch (this.selectedEvent.rule) {
                case 'daily': {
                    newDate.setDate(newDate.getDate() + dateDifferance);
                    break;
                }
                case 'weekly': {
                    dateDifferance = this.occurrences * 7 - 1;
                    newDate.setDate(newDate.getDate() + dateDifferance);
                    break;
                }
                case 'monthly': {
                    newDate.setMonth(newDate.getMonth() + dateDifferance);
                    break;
                }
                case 'yearly': {
                    newDate.setFullYear(newDate.getFullYear() + dateDifferance);
                    break;
                }
                default: {
                    break;
                }
            }
            newDate.setMinutes(newDate.getMinutes() + 1);
            this.selectedEvent.end_recurring_period = newDate;
        } else {
            this.occurrences = undefined;
            this.toaster.pop('warning', 'Validation Failed', 'Event occurrences count must be a positive number!');
        }
    }

    public checkoccurrences(): void {
        let dateDifferance: number = ((moment(this.selectedEvent.end_recurring_period).diff(this.selectedEvent.start)) - 60000) / 86400000;
        if (dateDifferance % 1 === 0) {
            dateDifferance += 1;
            switch (this.selectedEvent.rule) {
                case 'daily': {
                    this.occurrences = dateDifferance;
                    break;
                }
                case 'weekly': {
                    this.occurrences = dateDifferance / 7;
                    break;
                }
                case 'monthly': {
                    this.occurrences = dateDifferance;
                    break;
                }
                case 'yearly': {
                    this.occurrences = dateDifferance;
                    break;
                }
                default: {
                        break;
                    }
            }
            this.selectedEvent.ends = 'after';
        }
    }
}

angular.module('beneple.calendar').controller('EditModalEventController', EditModalEventController);



// WEBPACK FOOTER //
// ./frontend/scripts/calendar/controllers/edit-modal-event.controller.ts